import { Box, Popover } from '@ff-it/ui';
import { BlockWidget } from 'components';
import { fmt } from 'utilities';
import type { LinkerContext } from '../types';
import { ExpenseRowsPopover } from './ExpenseRowsPopover';
import { LinkableRowsPopover } from './LinkableRowsPopover';
import { centeredCell, clickable, numberCell, tableCell } from './style.css';
import type { ImportedBlockGroup } from './types';

interface RowProps {
  group: ImportedBlockGroup;
  linkerContext: LinkerContext;
}

/**
 * A single row in the ImportedBlocksLinker table - represents expense rows and linkable campaign block rows,
 * grouped under the same imported block code.
 */
export function Row({ group, linkerContext }: RowProps) {
  const showExpensePopover = group.expenseRows.length > 0;
  const showLinkablePopover = group.linkableRows.length > 0;

  return (
    <>
      <td className={centeredCell} />
      <td className={tableCell}>
        {group.reason ? (
          <Box>
            {group.block ? <BlockWidget {...group.block} link flat /> : group.blockCode}
            <Box textSize="xs" className="text-danger">
              {group.reason}
            </Box>
          </Box>
        ) : group.block ? (
          <BlockWidget {...group.block} link flat />
        ) : (
          group.blockCode
        )}
      </td>
      <td className={centeredCell} />
      <td className={numberCell}>
        {showExpensePopover ? (
          <Popover placement="auto" offsetOptions={0} content={<ExpenseRowsPopover rows={group.expenseRows} />}>
            <span role="button" className={clickable}>
              {fmt(group.expenseAmount)}
            </span>
          </Popover>
        ) : (
          fmt(group.expenseAmount)
        )}
      </td>
      <td className={numberCell}>
        {showLinkablePopover ? (
          <Popover
            placement="auto"
            offsetOptions={6}
            content={
              <LinkableRowsPopover linkableIds={group.linkableRows.map((r) => r.id)} linkerContext={linkerContext} />
            }
          >
            <span role="button" className={clickable}>
              {fmt(group.linkableAmount)}
            </span>
          </Popover>
        ) : (
          fmt(group.linkableAmount)
        )}
      </td>
      <td className={centeredCell} />
    </>
  );
}
